import { ApiEnvironment } from '../../models/api-environment';

export class CpihMessageExporterEnvironment extends ApiEnvironment {
  messageConsumerPartnerUrl(consumer: string, partner: string) {
    return `${this.baseUrl}/api/message/consumer/${consumer}/partner/${partner}`;
  }

  override resolve(environment: unknown) {
    return environment instanceof CpihMessageExporterEnvironment
      ? environment
      : this;
  }
}

export const ciphMessageExporterEnvironment =
  new CpihMessageExporterEnvironment();
